<picture
  *ngIf="!supportsNativeLoading"
  class="picture"
  [ngClass]="{
    'picture--has-figcaption': figcaption
  }"
>
  <ng-container *ngFor="let sizeMax of sizes">
    <source
      *ngIf="sizeMax.max"
      media="{{ sizeMax.max }}"
      type="image/webp"
      [attr.data-lazy-srcset]="source + '?' + sizeMax.size + '&q=70&fm=webp'"
    />
    <source
      *ngIf="!sizeMax.max"
      type="image/webp"
      [attr.data-lazy-srcset]="source + '?' + sizeMax.size + '&q=70&fm=webp'"
    />
    <img
      *ngIf="!sizeMax.max"
      [ngClass]="[type, backgroundClass, containClass]"
      class="picture__image"
      lazy-loading
      [attr.data-lazy-src]="source + '?' + sizeMax.size + jpgQueryParam"
      [alt]="alt"
    />
  </ng-container>
  <figcaption *ngIf="figcaption">Photo: {{ figcaption }}</figcaption>
</picture>

<picture
  *ngIf="supportsNativeLoading"
  class="picture"
  [ngClass]="{
    'picture--has-figcaption': figcaption
  }"
>
  <ng-container *ngFor="let sizeMax of sizes">
    <source
      *ngIf="sizeMax.max"
      media="{{ sizeMax.max }}"
      type="image/webp"
      [srcset]="source + '?' + sizeMax.size + '&q=70&fm=webp'"
    />
    <source *ngIf="!sizeMax.max" type="image/webp" [srcset]="source + '?' + sizeMax.size + '&q=70&fm=webp'" />
    <img
      *ngIf="!sizeMax.max"
      [ngClass]="[type, backgroundClass, containClass]"
      class="picture__image"
      loading="lazy"
      [src]="source + '?' + sizeMax.size + jpgQueryParam"
      [alt]="alt"
    />
  </ng-container>
  <figcaption *ngIf="figcaption">Photo: {{ figcaption }}</figcaption>
</picture>
